// Spec §4.3: Extract useState logic for ellipsis text truncation detection
import { useState } from 'react';

/**
 * Tracks whether the tooltip formatter's text is currently clipped so the tooltip is only shown when needed. Holds a truncated boolean in state and exposes its setter to the renderer.
 *
 * @returns The truncation flag and its setter.
 */
export const useTooltipFormatter = () => {
  const [truncated, setTruncated] = useState(false);

  return { truncated, setTruncated };
};
